import React, { PureComponent } from "react";

import styles from "./TopMedia.local.scss";
import classnames from "classnames";
import { getDateLabel, addLandaSize } from "Utils";
import _ from "i18n";

export default class TopMediaComponent extends PureComponent {
  state = {
    index: 0
  };
  handleNextClick = () => {
    const { medias } = this.props;
    const { index } = this.state;
    if (index + 1 < medias.items.length) {
      this.setState({
        index: index + 1
      });
    }
  };
  handlePreviewClick = () => {
    const { index } = this.state;
    if (index > 0) {
      this.setState({
        index: index - 1
      });
    }
  };
  render() {
    const { index } = this.state;
    const { medias, lng } = this.props;
    const topMedias = medias.items;
    const titleAttr = `title${lng.charAt(0).toUpperCase() + lng.slice(1)}`;
    const fullMediaUrl =
      topMedias.length > 0 && topMedias[index].fullMediaUrl
        ? addLandaSize(topMedias[index].fullMediaUrl, 400)
        : "/img/no-image.png";
    return (
      <div>
        {topMedias.length > 0 ? (
          <div className={styles.topMedia}>
            <div
              className={styles.bg}
              style={{
                background: `linear-gradient(270deg,
              rgba(16, 73, 144, 0.7) 0%, rgba(41, 57, 77, 0.7) 0%),
              url("${fullMediaUrl}") no-repeat top center / cover`
              }}
            />
            <div className={classnames(styles.content, "grid-x")}>
              <div
                className={classnames(styles.preview, "cell small-12 medium-7")}
              >
                <ul className={classnames(styles.list, "grid-x")}>
                  <li
                    style={{
                      backgroundImage: `url("${fullMediaUrl}")`
                    }}
                  />
                </ul>
              </div>
              <div
                className={classnames(styles.slick, "cell small-12 medium-5")}
              >
                <h2>{_("Top medias !")}</h2>
                <ul>
                  <li>
                    <div className={styles.date}>
                      <span>
                        {" "}
                        {getDateLabel(topMedias[index].createdAt, false)}
                      </span>
                      <a href={fullMediaUrl} target="_blank" download>
                        <i className="icon-cloud-download" />
                      </a>
                    </div>
                    <h3>{topMedias[index][titleAttr]}</h3>
                  </li>
                </ul>
                {topMedias.length > 1 && (
                  <div className={styles.arrow}>
                    <i
                      className={classnames(
                        index < 1 ? styles["btn-disabled"] : "",
                        "icon",
                        "icon-arrow-left"
                      )}
                      onClick={() => this.handlePreviewClick()}
                    />
                    <i
                      className={classnames(
                        index + 1 < topMedias.length
                          ? ""
                          : styles["btn-disabled"],
                        "icon",
                        "icon-arrow-right"
                      )}
                      onClick={() => this.handleNextClick()}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Community/TopMedia/TopMediaComponent.js